import BaseView from "scripts/views/baseView";
import CommentDisplayNameDialogView from "scripts/views/commentDisplayNameDialogView";
import CommentLoadingDialogView from "scripts/views/commentLoadingDialogView";
import DisplayNameModel from "scripts/models/displayNameModel";
import templateCommentForm from "templates/commentForm.hbs";

class CommentFormView extends BaseView {
  get tagName() {
    return "div";
  }

  get className() {
    return "row";
  }

  get template() {
    return templateCommentForm;
  }

  get events() {
    return {
      "submit .comment-new-form": "checkDisplayName",
    };
  }

  constructor(options) {
    super(options);

    options = options || {};

    this.disqusModel = options.disqusModel;

    this.data = {
      parentId: options.parentId || "",
      textMessage: options.textMessage || "",
      displayName: this.disqusModel.get("disqusDisplayName") || "",
      avatar: this.disqusModel.get("disqusAvatar") || "",
    };
  }

  render() {
    this.$el.html(this.template(this.data));

    return this;
  }

  checkDisplayName(event) {
    // If user doesn't have a display name, prompt for one
    if (!this.disqusModel.has("disqusDisplayName")) {
      event.preventDefault();
      event.stopPropagation();

      const prompt = this.addSubView(
        new CommentDisplayNameDialogView({
          el: $("#comments-display-name-modal"),
        }).once("confirm", displayName => {
          prompt.remove();

          const loading = this.addSubView(
            new CommentLoadingDialogView(),
          ).render();
          // const userId = chan('security').request('user').getUserId();
          const displayNameModel = new DisplayNameModel({
            displayName: displayName,
          });

          displayNameModel
            .save({}, { type: "put" })
            .then(() => {
              this.disqusModel.set("disqusDisplayName", displayName);

              // Submit the comment
              $(event.currentTarget).submit();
            })
            .finally(() => {
              loading.remove();
            });
        }),
      ).render();
    }
  }
}

export default CommentFormView;
